import React from 'react'
import { Link } from 'react-router-dom'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg'
  linkTo?: string
  light?: boolean
}

/**
 * Wordmark-only, per Mitel rebrand (skilflow-ux v1.11, Section 1): no icon mark.
 * Color comes from --logo-text (#15325f on light bg) unless `light` is set, which
 * renders white for placement on dark surfaces (e.g. the sidebar).
 * Font: Museo Sans not yet available in this project — falls back to Inter until
 * the licensed font files are sourced; --font-sans lists Museo Sans first so it
 * upgrades automatically once added.
 */
export default function Logo({ size = 'md', linkTo, light }: LogoProps) {
  const textClass = size === 'sm' ? 'text-[13px]' : size === 'lg' ? 'text-[17px]' : 'text-[15px]'

  const inner = (
    <span
      className={`${textClass} font-bold`}
      style={{ color: light ? '#ffffff' : 'var(--logo-text)', fontFamily: "'Museo Sans', 'Inter', sans-serif" }}
    >
      Skilflow
    </span>
  )

  if (linkTo) return <Link to={linkTo} className="no-underline flex-shrink-0">{inner}</Link>
  return inner
}
